/**
 *  RaceTrack
 *
 *  Created by Legman on 21/03/2017.
 *
 */

/**
 * @class
 * @memberOf race
 */
export default class RaceTrack {
    /**
     * @param {*} data
     */
    constructor(data) {
        /**
         * @member {*}
         */
        this.meta = data.meta;

        /**
         * @member {*}
         */
        this.objects = data.objects;

        /**
         * @member {*}
         */
        this.track = data.track;

        /**
         * @member {*}
         */
        this.textures = data.textures;
    }

    /**
     * @returns {string}
     */
    get name() {
        return this.meta.name;
    }

    /**
     * @returns {number}
     */
    get length() {
        return this.track.length;
    }
}
